import { colors } from './colors';
import { muiTheme } from './muiTheme';

export const darkTheme: any = {
  palette: {
    mode: 'dark',
    ...colors,
    text: {
      primary: '#FFF',
    },
    primary: {
      ...colors.primary,
      light: '#EDE7FF',
    },
    background: {
      default: '#2B2B2B',
      paper: '#353535',
    },
  },
  ...muiTheme,
};
//333232
